var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M91 3c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12S97.627 3 91 3zm6.464 9.535c.006.133.009.265.009.397 0 4.068-3.095 8.756-8.756 8.756A8.697 8.697 0 0184 20.305c.241.029.486.042.735.042a6.157 6.157 0 003.821-1.318 3.08 3.08 0 01-2.875-2.137 3.072 3.072 0 001.39-.053 3.078 3.078 0 01-2.469-3.017v-.039c.415.231.889.369 1.394.385a3.077 3.077 0 01-.953-4.108 8.737 8.737 0 006.343 3.216 3.078 3.078 0 015.244-2.807 6.185 6.185 0 001.955-.747 3.09 3.09 0 01-1.354 1.703 6.15 6.15 0 001.768-.484 6.204 6.204 0 01-1.535 1.594z",
    transform: "translate(-76)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7b9ffcdd54e9082ad5736c6e5d88ac07.svg";
export { ForwardRef as ReactComponent };